import React from 'react'
import { Card, Time, Subtitle, Container, Title } from './PayLater.style'
import { Redirect, useLocation } from 'react-router-dom'
import { DateTime } from 'luxon'
import FormPlateInput from 'parkdepot-shared/components/LPInput'
import { useStyletron } from 'parkdepot-shared/theme'
import { useTranslation } from 'react-i18next'
import carpayHomeRoute from '../Home/route.const'

const CarpayPayLater = () => {
    const now = DateTime.now()
    const { search } = useLocation()
    const { t } = useTranslation()
    const [css, theme] = useStyletron()
    const searchParams = new URLSearchParams(search)
    const plate = searchParams.get('plate')

    if (!plate) {
        return <Redirect to={carpayHomeRoute} />
    }

    return (
        <Container>
            <Card>
                <i className={`wemolo-clock ${css({ fontSize: '3.4rem', color: theme.colors.warning300 })}`} />
                <Title>{t('carpay.payLater.title')}</Title>

                <Subtitle>{t('carpay.payLater.subtitle')}</Subtitle>

                <div>
                    <FormPlateInput disabled readOnly value={plate} />
                    <Time>{now.toFormat('dd.MM.yyyy HH:mm')}</Time>
                </div>
            </Card>
        </Container>
    )
}

export default CarpayPayLater
